import { render } from "./GeneralSpecsValues.vue?vue&type=template&id=0f731362&scoped=true&ts=true"
import script from "./GeneralSpecsValues.vue?vue&type=script&lang=ts"
export * from "./GeneralSpecsValues.vue?vue&type=script&lang=ts"

import "./GeneralSpecsValues.vue?vue&type=style&index=0&id=0f731362&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f731362"]])

export default __exports__